import { render, staticRenderFns } from "./EmissionsFactors.vue?vue&type=template&id=51f0aad6"
import script from "./EmissionsFactors.vue?vue&type=script&lang=js"
export * from "./EmissionsFactors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports